import React, { useState } from "react";
import { getInitials } from "../CallLeadDetails.utils";

const ProfileAvatar = ({ name, imageUrl }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = imageUrl && !imageFailed;

  return (
    <div className="cw-profile-avatar">
      {showImage ? (
        <img
          src={imageUrl}
          alt={name ? name + "'s profile" : "Customer profile"}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span aria-hidden="true">{getInitials(name)}</span>
      )}
    </div>
  );
};

export default ProfileAvatar;
